import { render } from "./ContactInformationTab.vue?vue&type=template&id=29767726"
import script from "./ContactInformationTab.vue?vue&type=script&lang=js"
export * from "./ContactInformationTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__